<template>
  <div class="content" style="overflow-y: auto; margin-top: 0px">
    <div>
      <div class="button-area">
        <el-button
          icon="el-icon-plus"
          size="medium"
          type="info"
          @click="add(1, '')"
          >新增人员</el-button
        >
        <el-button size="medium" type="danger" @click="getDeleteData(1, '')"
          >批量删除</el-button
        >
        <div class="fr line-h40 h40 font-S16 mr16">
          {{ staffName }}，有<b class="fontC-4fa1a4"> {{ page.totalRows }} </b
          >个备案人员
        </div>
        <!-- <el-button plain size="medium">历史数据</el-button> -->
      </div>
      <div class="back-color-fff p16">
        <el-table
          :data="tableData"
          @selection-change="handleSelectionChange"
          border
          style="width: 100%"
          v-loading="tableLoading"
        >
          <el-table-column
            type="selection"
            width="60"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column label="序号" header-align="left" align="left">
            <template slot-scope="scope">
              <!-- {{ scope.$index + 1 }} -->
              {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="staffName"
            label="姓名"
            header-align="left"
            align="left"
          ></el-table-column>
          <el-table-column
            prop="mobileNo"
            label="手机号"
            header-align="left"
            align="left"
          ></el-table-column>
          <el-table-column
            prop="logonUser"
            label="账号"
            header-align="left"
            align="left"
          ></el-table-column>
          <el-table-column label="操作" header-align="right" align="right">
            <template slot-scope="scope">
              <a class="txt-color-red" @click="getDeleteData(2, scope.row.guid)"
                >删除</a
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        class="pt pb back-color-fff"
        style="padding: 16px"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 100, 200]"
        :current-page="page.pageIndex"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.totalRows"
      >
      </el-pagination>
    </div>

    <!-- 新增部门/成员弹框 -->
    <el-dialog
      title="选择部门/人员"
      :visible.sync="visible3"
      width="60%"
      center
    >
      <div>
        <div class="select-box">
          <div class="box-left fl">
            <el-input
              v-model="filterText2"
              class="mt15"
              placeholder="请输入部门/人员名称"
            ></el-input>
            <el-tree
              class="filter-tree"
              :data="areaData"
              :props="defaultProps"
              :show-checkbox="true"
              node-key="guid"
              :filter-node-method="filterNodeDep"
              @node-click="handleNodeClick1"
              ref="treeDep"
              @check-change="checkChange"
            >
              <div class="custom-tree-node" slot-scope="{ node, data }">
                <img :src="data.icon" alt="" />
                <!-- <img src="../../assets/images/icon_per.png" alt=""> -->
                <span
                  >{{ data.label }}
                  <span class="remark-class" v-if="data.remark"
                    >（{{ data.remark }}）</span
                  ></span
                >
              </div>
            </el-tree>
          </div>
          <div class="box-right fr">
            <p class="fontC-bbb fl">已选{{ departmentList.length }}人</p>
            <el-button
              size="medium"
              type="danger"
              @click="delDepartment()"
              class="fr"
              style="margin-top: 5px"
              >批量删除
            </el-button>
            <el-table
              :data="departmentList"
              border
              height="280px"
              style="width: 100%"
              @selection-change="handleSelectionChange1"
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                show-overflow-tooltip
                prop="label"
                label="名称"
              >
                <template slot-scope="scope">
                  {{ scope.row.label }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="visible3 = false"
          >取消</el-button
        >
        <el-button
          size="medium"
          type="info"
          @click="submitDepartment()"
          v-loading.fullscreen.lock="fullscreenLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import areaJson from "../../assets/js/china_address_v4.js";
import citys from "../../components/citys.vue";
export default {
  components: {
    citys,
  },
  data() {
    return {
      staffName: "",
      visible3: false,
      filterText2: "",
      departmentList: [],
      areaData: [],
      defaultProps: {
        id: "id",
        label: "label",
        children: "children",
      },
      departmentData: [],
      departList: [],
      fullscreenLoading: false,
      workareaList: "",
      textTitle: "",
      right: "",
      dialogVisible: false,
      dialogFormVisible: false,
      formLabelWidth: "120px",
      superiorOrganization: [],
      organisationGuidList: [],
      positionList: [],
      roleList: [],
      ruleForm: {
        guid: "",
        tenantGuid: "",
        jobNumber: "",
        logonUser: "",
        staffName: "",
        helpCode: "",
        bizState: "Y",
        mobileNo: "",
        email: "",
        isTenantInit: "N",
        leaderGuid: "",
        merchantGuid: "",
        organisationGuid: "",
        positionGuids: "",
        province: "",
        city: "",
        pwd: "",
        district: "",
        venue: "",
        address: "",
        sex: "M",
        staffType: "1",
        remark: "",
        weChatNo: "",
        weChatOpentId: "",
        idCode: "",
        roleGuids: [],
        sendTenantGuid: "",
        areaList: [],
        operationUnitGuid: "",
      },
      defaultPropsOrganisation: {
        id: "guid",
        label: "organisationName",
        children: "children",
      },
      // defaultPropsOrganisationCascader:{
      //    value: "guid",
      //    label: "organisationName",
      //    children:"children"
      // },
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: "",
        logonUser: "",
        staffName: "",
        mobileNo: "",
        staffType: "1",
        bizState: "Y",
        organisationGuid: "",
      },
      staffDetail: "",
      tableData: [],
      rules: {
        staffName: [
          { required: true, message: "请输入人员名称", trigger: "blur" },
          { min: 1, max: 30, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        staffType: [
          { required: true, message: "请输入人员类型", trigger: "blur" },
          { min: 1, max: 30, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        jobNumber: [
          { required: true, message: "请输入工号", trigger: "blur" },
          { min: 1, max: 30, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        logonUser: [
          { required: true, message: "请输入账号", trigger: "blur" },
          { min: 1, max: 30, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        mobileNo: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { min: 1, max: 30, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        organisationGuid: [
          { required: true, message: "请输入所属部门", trigger: "blur" },
          // { message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        positionGuids: [
          { required: true, message: "请输入岗位", trigger: "blur" },
          { message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        roleGuids: [
          { required: true, message: "请输入角色", trigger: "blur" },
          // { message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
      },
      filterText: "",
      multipleSelection: [],
      tableLoading: false,
      tenantList: [],
      addressOptions: areaJson,
      operationUnitList: [],
      delList: [],
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    this.areaData = [];
    this.staffName = this.$route.query.tenantName;
    // 列表
    this.getData(false);
    // this.getSuperiorOrganization();
    // this.getAppsideData();
    // this.getPositionListData();
    // this.getTenantOperationRelList();
    // this.getOperationUnitList();
  },
  methods: {
    checkChange(val) {
      console.log(this.$refs.treeDep.getCheckedNodes());
      this.departmentList = [];
      let checkNodes = this.$refs.treeDep.getCheckedNodes();
      if (checkNodes.length > 0) {
        checkNodes.forEach((i) => {
          if (i.usertype == 1) {
            this.departmentList.push(i);
          }
        });
      }
      // this.departmentList = this.$refs.treeDep.getCheckedNodes();
      console.log("1111111", this.departmentList);
    },
    handleSelectionChange1(val) {
      let self = this;
      self.delList = val;
      console.log(val);
    },
    filterNodeDep(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    //部门弹框选择
    handleNodeClick1(data) {
      let self = this;
      console.log(data);
      console.log(self.departmentList);
    },
    //获取组织
    getOrganisation() {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msPersonnelService}/organisation/data/get-organisation-staff-hierarchical?&tenantGuid=` +
            self.$store.getters.getTenantGuid +
            "&sendTenantGuid=" +
            self.$route.query.tenantGuid
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.areaData = res.data.data;
            self.treeData(self.areaData);
          } else {
            self.$message.error(res.data.msg);
            self.areaData = [];
          }
        });
    },
    treeData(areaData) {
      var self = this;
      // const treeData = [];
      // const getPerson = () => {};
      const fn = (tree) => {
        tree.forEach(async (k) => {
          k.label = k.organisationName;
          k.id = k.guid;
          k.icon = require("../../assets/images/ico_ora.png");
          // 根据id获取人员数据,(注意转为树类型)
          if (k) {
            // const person = await self.getStaff(k.guid);
            k.staffList = [];
            if (k.staffs) {
              k.staffs.forEach((d) => {
                let item = {
                  usertype: 1,
                  id: d.guid,
                  label: d.staffName + d.mobileNo,
                  icon: require("../../assets/images/icon_per.png"),
                };
                k.staffList.push(item);
              });
            }
            const person = k.staffList;
            const isValid = (val) => {
              return val && val !== null && JSON.stringify(val) !== "[]";
            };
            // 将人员数据拼接到chilren里面
            if (k.children) {
              fn(k.children);
              isValid(person) && (k.children = [...k.children, ...person]);
              // 有子元素，需要调用自身
            } else {
              isValid(person) && (k.children = person);
            }
          }
        });
      };
      fn(areaData);
      console.log(areaData);
    },
    //查询人员
    getStaff(organisationGuid) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: 10,
        tenantGuid: self.$store.getters.getTenantGuid,
        staffType: "1",
        bizState: "Y",
        organisationGuid: organisationGuid,
        sendTenantGuid: self.$route.query.tenantGuid,
      };
      return new Promise((resolve, reject) => {
        self.api
          .postJson(`/${serverConfig.msPersonnelService}/staff/data/get`, query)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              // self.tableLoading = false;
              const records = res.data.data.records;
              (records || []).forEach((k) => {
                k.label = k.staffName;
                k.id = k.guid;
                k.icon = require("../../assets/images/icon_per.png");
              });
              resolve(records);
            } else {
              self.$message.error(res.data.msg);
            }
          });
      });
    },
    //运营获取药企
    getTenantOperationRelList() {
      let self = this;
      self.api
        .postJson(
          `/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`,
          { tenantGuid: self.$store.getters.getTenantGuid, isService: true }
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    submitDepartment() {
      let self = this;
      if (!self.departmentList) {
        self.$message.error("请选择人员!");
        return;
      }
      let staffGuids = [];
      self.departmentList.forEach((i) => {
        staffGuids.push(i.id);
      });
      self.fullscreenLoading = true;
      self.api
        .postJson(
          `/${serverConfig.msPersonnelService}/staff/data/add-staff-filing`,
          {
            serviceSenantGuid: self.$store.getters.getTenantGuid,
            tenantGuid: self.$route.query.tenantGuid,
            staffGuids: staffGuids,
          }
        )
        .then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success("添加备案人员成功");
            self.visible3 = false;
            this.getData(true);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    delDepartment() {
      let self = this;
      if (self.delList == null || self.delList.length == 0) {
        self.$message.error("请勾选部门！");
        return;
      }
      self.delList.forEach(function (j) {
        self.departmentList.forEach(function (i, index) {
          if (i.id == j.id) {
            self.departmentList.splice(index, 1);
          }
        });
      });
      this.$refs.treeDep.setCheckedNodes(this.departmentList);
    },
    //运营单元列表
    getOperationUnitList() {
      let self = this;
      self.api
        .postJson(
          `/${serverConfig.msPersonnelService}/operationunit/data/get`,
          { tenantGuid: self.$store.getters.getTenantGuid, isService: true }
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.operationUnitList = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    incres(area) {
      let self = this;
      self.ruleForm.province = area[0];
      self.ruleForm.city = area[1];
      self.ruleForm.district = area[2];
    },
    handleNodeCilck(data) {
      // console.log(data);
      let self = this;
      self.page.organisationGuid = data.guid;
      self.getData(true);
      // node.
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.organisationName.indexOf(value) !== -1;
    },
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: "",
        logonUser: "",
        staffName: "",
        mobileNo: "",
        staffType: "1",
        bizState: "Y",
        organisationGuid: "",
      };
      self.getData(true);
    },
    add(flg, row) {
      let self = this;
      self.workareaList = [];
      if (flg == 1) {
        self.textTitle = "新增人员";
        self.visible3 = true;
        self.departmentList = [];
        self.delList = [];
        this.getOrganisation();
        self.$nextTick(() => {
          self.$refs.treeDep.setCheckedNodes(self.departmentList);
        });
      } else {
        self.textTitle = "编辑人员";
        self.ruleForm.guid = row.guid;
        self.workareaList.push(row.province, row.city, row.district);
        self.getStaffDetail(row.guid);
      }
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.page.tenantGuid = self.$store.getters.getTenantGuid;
      self.page.sendTenantGuid = self.$route.query.tenantGuid;
      self.page.staffType = "2";
      self.tableLoading = true;
      self.page.totalPage = 0;
      self.page.totalRows = 0;
      self.api
        .postJson(
          `/${serverConfig.msPersonnelService}/staff/data/get`,
          self.page
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableLoading = false;
            self.tableData = res.data.data.records;
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function (item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
      });
    },

    getDeleteData(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelection.length == 0) {
          self.$message.error("请勾选数据！");
          return;
        }
      } else {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }
      let DeleteStaffRequestVO = {
        guids: self.multipleSelection,
        tenantGuid: self.$store.getters.getTenantGuid,
        isVaildInitStaff: true,
      };
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          self.api
            .postJson(
              `/${serverConfig.msPersonnelService}/staff/data/delete-by-tenant`,
              DeleteStaffRequestVO
            )
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.multipleSelection = [];
                self.$message.success("删除人员成功");
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    submitForm(formName) {
      let self = this;
      if (!self.ruleForm.pwd) {
        self.$message.error("密码不能为空！");
        return;
      }
      let positionGuids = [];
      positionGuids.push(self.ruleForm.positionGuids);
      self.$refs[formName].validate((valid) => {
        if (valid) {
          let pwd = self.$md5(self.ruleForm.pwd);
          let promise = {
            tenantGuid: self.page.tenantGuid,
            jobNumber: self.ruleForm.jobNumber,
            logonUser: self.ruleForm.logonUser,
            staffName: self.ruleForm.staffName,
            helpCode: self.ruleForm.helpCode,
            pwd: pwd,
            bizState: self.ruleForm.bizState,
            mobileNo: self.ruleForm.mobileNo,
            email: self.ruleForm.email,
            isTenantInit: self.ruleForm.isTenantInit,
            leaderGuid: self.ruleForm.leaderGuid,
            merchantGuid: self.ruleForm.merchantGuid,
            organisationGuid: self.ruleForm.organisationGuid.toString(),
            positionGuids: positionGuids,
            province: self.ruleForm.province,
            city: self.ruleForm.city,
            district: self.ruleForm.district,
            venue: self.ruleForm.venue,
            address: self.ruleForm.address,
            sex: self.ruleForm.sex,
            staffType: self.ruleForm.staffType,
            remark: self.ruleForm.remark,
            weChatNo: self.ruleForm.weChatNo,
            weChatOpentId: self.ruleForm.weChatOpentId,
            idCode: self.ruleForm.idCode,
            roleGuids: self.ruleForm.roleGuids,
          };
          self.api
            .postJson(
              `/${serverConfig.msPersonnelService}/staff/data/add`,
              promise
            )
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.dialogFormVisible = false;
                self.$message.success("添加人员成功");
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    upDateForm(formName) {
      let self = this;
      let positionGuids = [];
      positionGuids.push(self.ruleForm.positionGuids);
      self.$refs[formName].validate((valid) => {
        if (valid) {
          let pwd = self.$md5(self.ruleForm.pwd);
          let promise = {
            guid: self.ruleForm.guid,
            tenantGuid: self.page.tenantGuid,
            jobNumber: self.ruleForm.jobNumber,
            logonUser: self.ruleForm.logonUser,
            staffName: self.ruleForm.staffName,
            helpCode: self.ruleForm.helpCode,
            pwd: pwd,
            bizState: self.ruleForm.bizState,
            mobileNo: self.ruleForm.mobileNo,
            email: self.ruleForm.email,
            isTenantInit: self.ruleForm.isTenantInit,
            leaderGuid: self.ruleForm.leaderGuid,
            merchantGuid: self.ruleForm.merchantGuid,
            organisationGuid: self.ruleForm.organisationGuid.toString(),
            positionGuids: positionGuids,
            province: self.ruleForm.province,
            city: self.ruleForm.city,
            district: self.ruleForm.district,
            venue: self.ruleForm.venue,
            address: self.ruleForm.address,
            sex: self.ruleForm.sex,
            staffType: self.ruleForm.staffType,
            remark: self.ruleForm.remark,
            weChatNo: self.ruleForm.weChatNo,
            weChatOpentId: self.ruleForm.weChatOpentId,
            idCode: self.ruleForm.idCode,
            roleGuids: self.ruleForm.roleGuids,
          };
          self.api
            .put(
              `/${serverConfig.msPersonnelService}/staff/data/update`,
              promise
            )
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.dialogFormVisible = false;
                self.$message.success("编辑人员成功");
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
    getLevel(val) {
      let self = this;
      console.log("789", val, val.length);
      if (val.length > 0) {
        self.ruleForm.organisationGuid = val[val.length - 1].toString();
      }
      // console.log(self.ruleForm.level);
    },
  },
};
</script>
<style scoped>
.ipt-sty {
  width: 70% !important;
}

.person-type /deep/.el-radio {
  margin-right: 10px;
}

/* 选项卡 */
.menu-tab {
  width: 20%;
  float: left;
  padding: 15px;
  box-sizing: border-box;
}

.tab-plane {
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  /* border-radius: 6px; */
  border: 1px solid #ddd;
}

.tab-plane .tab-list {
  width: 50%;
  line-height: 32px;
  background: rgb(240, 239, 239);
  cursor: pointer;
  /* border-radius: 6px; */
}

.tab-active {
  color: #4fa1a4 !important;
  background: #fff !important;
  border: 1px solid #4fa1a4;
}

.tags-logo {
  width: 16px;
  margin-top: 2px;
  margin-right: 10px;
}

.tags-edit {
  width: 20px;
  margin-top: 2px;
  margin-right: 10px;
}

.tags-del {
  width: 16px;
  margin-top: 2px;
}

.tags-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  /* line-height: 40px; */
  text-align: left;
  padding: 0 10px;
  cursor: pointer;
}

.tags-list-left {
  width: calc(100% - 60px);
  display: flex;
  align-items: center;
}

.tags-list-left span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tags-list:hover {
  background: rgb(245, 244, 244);
}

.tags-active {
  color: #4fa1a4 !important;
  background: rgb(245, 244, 244);
}

.edit-tags-text {
  padding: 0 80px;
  display: flex;
}

/* 表格 */
.table-tags {
  display: flex;
  justify-content: space-between;
}

.person-tags {
}

.tags-left {
  font-weight: 600;
}

.tags-right {
  cursor: pointer;
  text-decoration: underline;
}

.tags-detail {
  padding: 0 60px;
  text-align: left;
  margin-bottom: 30px;
}

.tags-detail-name {
  display: inline-block;
  width: 120px;
  text-align: right;
  margin-right: 20px;
}

.tags-detail-title {
  font-size: 16px;
  font-weight: 700;
}

.sure-btn {
  width: 50%;
  color: #fff;
  background: #4fa1a4;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 10px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.tab-input {
  width: 100%;
  margin-bottom: 10px;
}

.custom-tree-node {
  display: flex;
  align-items: center;
}

.custom-tree-node img {
  width: 18px;
  margin-right: 10px;
}
</style>
